"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const HFAPublisherNumberToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'If you are an HFA affiliate, you can find this number in your HFA portal.' }));
exports.default = HFAPublisherNumberToolTip;
